import React from "react";

import { SessionStore, LocaleStore, RouterStore } from "@/stores";
import { inject, observer } from "mobx-react";
import { project, assets } from "@/config.json";
import { loadImage } from "@/utils";

interface StoreProps {
  session: SessionStore;
  router: RouterStore;
  locale: LocaleStore;
}

@inject("session", "locale", "router")
@observer
class Safeguard extends React.Component<StoreProps, any> {
  constructor(props) {
    super(props);
  }
  state = {
    safeUrl: "",
  };
  componentDidMount() {
    loadImage(assets.safeguard).then((asset) => {
      this.setState({
        safeUrl: asset.default,
      });
    });
  }
  render() {
    const { safeUrl } = this.state;
    return (
      <div>
        <img src={safeUrl} style={{ width: "100%" }} />
      </div>
    );
  }
}

export default Safeguard as React.ComponentType;
